/* HEALR Wholesale — catalog inline add-to-cart + steppers */
(function () {
  function initSteppers(scope) {
    scope.querySelectorAll('.whsl-stepper').forEach(function (s) {
      var input = s.querySelector('input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var step = parseInt(input.getAttribute('step'), 10) || 1;
      s.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || min;
          input.value = Math.max(min, v + parseInt(b.getAttribute('data-step'), 10) * step);
        });
      });
    });
  }

  // Refresh and slide open the theme's cart drawer so partners can keep
  // shopping; fall back to the cart page if the drawer isn't on the page.
  function openCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { window.location.href = '/cart'; return; }
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.querySelector('.whsl-hdr__icon--cart');
        if (!link) return;
        var badge = link.querySelector('.whsl-hdr__count');
        if (!badge) { badge = document.createElement('span'); badge.className = 'whsl-hdr__count'; link.appendChild(badge); }
        badge.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  document.querySelectorAll('[data-wholesale-shop]').forEach(function (root) {
    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    var upc = parseInt(root.getAttribute('data-upc'), 10) || 1;
    initSteppers(root);

    root.querySelectorAll('[data-card-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-card]');
        var vid = btn.getAttribute('data-variant-id');
        var qtyEl = card ? card.querySelector('[data-qty]') : null;
        var cartons = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var quantity = cartons;
        if (!vid) return;

        var orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: quantity, properties: { _carton: upc + ' units / carton' } }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
            openCart();
          })
          .catch(function () {
            btn.textContent = 'Try again';
            setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
          });
      });
    });
  });
})();
